import RugCardReservationsStatus from './RugCardReservationsStatus'
export default RugCardReservationsStatus
